export default "/images/vendor/flag-icons/flags/4x3/ca.svg?f3f7109aa7e471fef1348c0bfc4e354c";